<template>
</template>
<script>
export default {
  name: 'deleteresource',
  props: {
    endpoint: {
      type: String,
      required: true
    },
    redirectRoute: {
      type: String,
      default: null
    },
    paramName: {
      type: String,
      default: 'id'
    }
  },
  mounted: function () {
    var vm = this
    var resourceId = this.$route.params[this.paramName]
    this.$http.delete(this.endpoint + '/' + resourceId).then(
      function (res) {
        if (res.status === 200) {
          vm.navigate()
        } else {
          vm.navigate()
          vm.$notify({
            group: 'full',
            text: res.data.msg
          })
        }
      }
    ).catch(function (error) {
      vm.navigate()
      vm.$notify({
        group: 'full',
        text: error.response ? error.response.data.msg : 'Delete failed'
      })
    })
  },
  methods: {
    navigate: function () {
      if (this.redirectRoute) {
        this.$router.push({name: this.redirectRoute})
      } else {
        this.$router.back()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DeleteResource.vue?d5fc5ba4